import { v4 } from 'uuid';
import { TableSettings } from '../TableSettings';
import { EntityType } from '../../comment';
import { translate } from '../../translation/Translator';

export const ProductMasterDataTableSettingsColumn = {
  productName: 'productName',
  productNumber: 'productNumber',
  files: 'files',
  ean: 'ean',
} as const;

export type ProductMasterDataTableSettingsColumn =
  (typeof ProductMasterDataTableSettingsColumn)[keyof typeof ProductMasterDataTableSettingsColumn];

export class ProductMasterDataTableSettings {
  static default(companyId: string) {
    return new TableSettings<ProductMasterDataTableSettingsColumn>({
      id: v4(),
      companyId,
      type: EntityType.pmd,
      columns: [
        {
          index: 0,
          column: ProductMasterDataTableSettingsColumn.productName,
          label: translate({ key: ProductMasterDataTableSettingsColumn.productName }),
        },
        {
          index: 1,
          column: ProductMasterDataTableSettingsColumn.productNumber,
          label: translate({ key: ProductMasterDataTableSettingsColumn.productNumber }),
        },
        {
          index: 2,
          column: ProductMasterDataTableSettingsColumn.ean,
          label: translate({ key: ProductMasterDataTableSettingsColumn.ean }),
        },
      ],
    });
  }
}
